import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import RankingSection from "./components/RankingSection";
import NewSeasonSection from "./components/NewSeasonSection";
import FeaturedPick from "./components/FeaturedPick";
import GenreSection from "./components/GenreSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main className="w-full">
        <Hero />
        <section className="w-full bg-background-100 border-b border-background-200">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-10">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              <a
                href="#ranking"
                className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xl">
                  <i className="ri-trophy-line" />
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    热门番剧排行榜
                  </h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                    本周热度与口碑综合 TOP 10，一眼看清当下值得关注的番剧。
                  </p>
                </div>
              </a>
              <a
                href="#new"
                className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 text-xl">
                  <i className="ri-calendar-check-line" />
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    本季新番推荐
                  </h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                    按题材筛选正在更新的新番，快速锁定你的追番方向。
                  </p>
                </div>
              </a>
              <a
                href="#genres"
                className="group flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 text-xl">
                  <i className="ri-price-tag-3-line" />
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    题材分类导航
                  </h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                    八种主要题材的定位说明与代表作品，按口味选择好看动漫。
                  </p>
                </div>
              </a>
            </div>
          </div>
        </section>
        <RankingSection />
        <NewSeasonSection />
        <FeaturedPick />
        <GenreSection />
        <GuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}